export default "__VITE_ASSET__mUz4v2NJ__"